import React from 'react';
import { useSelector } from 'react-redux';

const HIPAA = () => {
  const language = useSelector((state) => state.language);

  return (
    <div className={`min-h-screen bg-gradient-to-br from-white via-blue-50 to-indigo-50 py-20 px-4`} dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {language === "ar" ? "الامتثال لـ HIPAA" : language === "fr" ? "Conformité HIPAA" : "HIPAA Compliance"}
        </h1>

        <div className="bg-white rounded-xl shadow-lg p-8 space-y-6 text-gray-700">
          <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded mb-6">
            <p className="text-green-800 font-semibold">
              {language === "ar"
                ? "✓ RAQIB حصلت على شهادة HIPAA الكاملة"
                : language === "fr"
                ? "✓ RAQIB est entièrement certifiée HIPAA"
                : "✓ RAQIB is fully HIPAA certified"}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "ما هو HIPAA؟" : language === "fr" ? "Qu'est-ce que HIPAA?" : "What is HIPAA?"}
            </h2>
            <p className="leading-relaxed">
              {language === "ar"
                ? "قانون نقل المعلومات الصحية والمسؤولية (HIPAA) هو قانون فيدرالي أمريكي يحمي خصوصية بيانات المرضى والمعلومات الصحية المحمية."
                : language === "fr"
                ? "La loi HIPAA est une loi fédérale américaine qui protège la vie privée des informations de santé protégées des patients."
                : "HIPAA (Health Insurance Portability and Accountability Act) is a U.S. federal law that protects the privacy of protected health information."}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "التزام RAQIB" : language === "fr" ? "Engagement de RAQIB" : "RAQIB's Commitment"}
            </h2>
            <p className="leading-relaxed mb-4">
              {language === "ar"
                ? "نحن في RAQIB ملتزمون بأعلى معايير الحماية والخصوصية لبيانات المرضى. لقد قمنا بتنفيذ:"
                : language === "fr"
                ? "Chez RAQIB, nous nous engageons à respecter les normes les plus élevées de protection et de confidentialité des données des patients. Nous avons mis en œuvre:"
                : "At RAQIB, we are committed to the highest standards of patient data protection and privacy. We have implemented:"}
            </p>
            <ul className="space-y-3 ml-4">
              <li className="flex items-start">
                <span className="text-green-500 mr-3 font-bold">✓</span>
                <span>
                  {language === "ar"
                    ? "التشفير من النهاية إلى النهاية لجميع البيانات الحساسة"
                    : language === "fr"
                    ? "Chiffrement de bout en bout pour toutes les données sensibles"
                    : "End-to-end encryption for all sensitive data"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-3 font-bold">✓</span>
                <span>
                  {language === "ar"
                    ? "سجلات التدقيق الشاملة لجميع عمليات الوصول"
                    : language === "fr"
                    ? "Journaux d'audit complets pour tous les accès"
                    : "Comprehensive audit logs for all access"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-3 font-bold">✓</span>
                <span>
                  {language === "ar"
                    ? "سياسات التحكم في الوصول الدقيقة"
                    : language === "fr"
                    ? "Politiques de contrôle d'accès granulaires"
                    : "Granular access control policies"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-3 font-bold">✓</span>
                <span>
                  {language === "ar"
                    ? "اختبارات الأمان والتدقيق المنتظمة"
                    : language === "fr"
                    ? "Tests de sécurité et audits réguliers"
                    : "Regular security testing and audits"}
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-green-500 mr-3 font-bold">✓</span>
                <span>
                  {language === "ar"
                    ? "خوادم البيانات المحمية والنسخ الاحتياطية"
                    : language === "fr"
                    ? "Serveurs de données sécurisés et sauvegardes"
                    : "Secure data servers and backups"}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "اتفاقية شريك العمل (BAA)" : language === "fr" ? "Accord d'associé commercial (BAA)" : "Business Associate Agreement (BAA)"}
            </h2>
            <p className="leading-relaxed">
              {language === "ar"
                ? "RAQIB توفر اتفاقية شريك عمل (BAA) موقعة لجميع العملاء الذين يتعاملون مع المعلومات الصحية المحمية. يضمن هذا الترتيب الامتثال الكامل لنصوص HIPAA."
                : language === "fr"
                ? "RAQIB fournit un accord d'associé commercial (BAA) signé pour tous les clients traitant des informations de santé protégées. Cet arrangement garantit une conformité HIPAA complète."
                : "RAQIB provides a signed Business Associate Agreement (BAA) for all clients handling protected health information. This arrangement ensures full HIPAA compliance."}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-teal-600 mb-4">
              {language === "ar" ? "حقوق المريض" : language === "fr" ? "Droits des patients" : "Patient Rights"}
            </h2>
            <p className="leading-relaxed mb-3">
              {language === "ar"
                ? "بموجب HIPAA، للمرضى الحق في:"
                : language === "fr"
                ? "En vertu de HIPAA, les patients ont le droit de:"
                : "Under HIPAA, patients have the right to:"}
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>
                {language === "ar"
                  ? "الوصول إلى سجلاتهم الطبية"
                  : language === "fr"
                  ? "Accéder à leurs dossiers médicaux"
                  : "Access their medical records"}
              </li>
              <li>
                {language === "ar"
                  ? "طلب تصحيحات السجلات"
                  : language === "fr"
                  ? "Demander des corrections de dossiers"
                  : "Request corrections to records"}
              </li>
              <li>
                {language === "ar"
                  ? "الحصول على نسخ من البيانات بتنسيقات مختلفة"
                  : language === "fr"
                  ? "Obtenir des copies de données dans différents formats"
                  : "Obtain copies of data in different formats"}
              </li>
              <li>
                {language === "ar"
                  ? "تقديم شكوى حول انتهاكات HIPAA"
                  : language === "fr"
                  ? "Déposer plainte pour violations HIPAA"
                  : "File complaints about HIPAA violations"}
              </li>
            </ul>
          </div>

          <div className="bg-teal-50 border-l-4 border-teal-500 p-4 rounded">
            <h3 className="font-semibold text-teal-900 mb-2">
              {language === "ar" ? "هل لديك أسئلة؟" : language === "fr" ? "Des questions?" : "Have Questions?"}
            </h3>
            <p className="text-sm text-gray-700">
              {language === "ar"
                ? "للمزيد من التفاصيل حول الامتثال لـ HIPAA في RAQIB، يرجى التواصل معنا على compliance@raqibapp.com"
                : language === "fr"
                ? "Pour plus de détails sur la conformité HIPAA chez RAQIB, veuillez nous contacter à compliance@raqibapp.com"
                : "For more details about HIPAA compliance at RAQIB, please contact us at compliance@raqibapp.com"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HIPAA;
